import { Formik } from "formik";
import React from "react";
import { useDispatch } from "react-redux";
import { productActions } from "reducers/productReducer";
import { Button, Form, Grid, Header, Segment } from "semantic-ui-react";
import Alerts from "utilities/Alerts";
import http from "utilities/http";
import addNewProductValidator from "validators/addNewProduct";
import CategoryInput from "./Inputs/CategoryInput";

function AddProduct({ name: newProductName }) {
	const dispatch = useDispatch();
	const submitProductAdd = async (values, handlers) => {
		try {
			const response = await http({
				method: "POST",
				url: "/products/add",
				data: {
					...values,
				},
			});

			console.log({ response });

			const { message, id } = response.data;

			Alerts.success(message);
			handlers.resetForm();

			const threshold = values.orderThreshold;

			delete values.orderThreshold;

			dispatch(
				productActions.addproduct({
					_id: id,
					...values,
					threshold,
				})
			);
		} catch (ex) {
			Alerts.httpException(ex);
		}
	};
	return (
		<>
			<Formik
				initialValues={{
					name: newProductName ?? "",
					category: "",
					rack: "",
					shelf: "",
					localName: "",
					orderThreshold: 0,
				}}
				onSubmit={submitProductAdd}
				validationSchema={addNewProductValidator}
			>
				{({
					values,
					errors,
					touched,
					handleSubmit,
					handleChange,
					handleBlur,
					isSubmitting,
				}) => (
					<Form onSubmit={handleSubmit}>
						<Header as="h2">Add New Product</Header>
						<Segment loading={isSubmitting}>
							<Grid
								columns={2}
								style={{
									marginTop: "0px",
									marginBottom: "0px",
								}}
							>
								<Grid.Column>
									<Form.Input
										name="name"
										placeholder="Product Name"
										value={values.name}
										onChange={handleChange}
										onBlur={handleBlur}
										label="Product Name"
									/>
									<p style={{ color: "red" }}>
										{errors.name &&
											touched.name &&
											errors.name}
									</p>
								</Grid.Column>
								<Grid.Column>
									<Form.Input
										name="localName"
										placeholder="Local name for product"
										value={values.localName}
										onChange={handleChange}
										onBlur={handleBlur}
										label="Local Name"
									/>
									<p style={{ color: "red" }}>
										{errors.localName &&
											touched.localName &&
											errors.localName}
									</p>
								</Grid.Column>
							</Grid>
							<CategoryInput />

							<Grid
								columns={3}
								style={{
									marginBottom: "0px",
								}}
							>
								<Grid.Column>
									<Form.Input
										name="rack"
										label="Rack"
										placeholder="Rack number the product is going into"
										value={values.rack}
										onChange={handleChange}
										onBlur={handleBlur}
									/>
									<p style={{ color: "red" }}>
										{errors.rack &&
											touched.rack &&
											errors.rack}
									</p>
								</Grid.Column>
								<Grid.Column>
									<Form.Input
										name="shelf"
										label="Shelf"
										placeholder="Shelf position of the product"
										value={values.shelf}
										onChange={handleChange}
										onBlur={handleBlur}
									/>

									<p style={{ color: "red" }}>
										{errors.shelf &&
											touched.shelf &&
											errors.shelf}
									</p>
								</Grid.Column>
								<Grid.Column>
									<Form.Input
										name="orderThreshold"
										label="Threshold"
										placeholder="Minimun order threshold"
										value={values.orderThreshold}
										onChange={handleChange}
										onBlur={handleBlur}
										type="number"
										min={0}
									/>
								</Grid.Column>
							</Grid>
							<Button type="submit" positive>
								Add Product
							</Button>
						</Segment>
					</Form>
				)}
			</Formik>
		</>
	);
}

export default AddProduct;
